import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Panel from 'components/Panel';
import Preloader from 'components/Preloader';
import FormErrorsBox from 'components/FormErrorsBox';
import StatusBadge from 'components/StatusBadge/StatusBadge';
import FeedRationForm from './components/FeedRationForm';
// hooks
import useFetchById from 'hooks/useFetchById';
// endpoints
import { getFeedRation, updateFeedRation } from 'endpoints/admin/feedRations';
// constants
import { feedRationFormName, feedRationsPath, medicationErrorKeys, rawMedicationErrorKeys } from './constants';
// utils
import handleFormErrors from 'utils/handleFormErrors';
import { showToastrMessage } from 'utils';
import { feedRationToFormValues, serializeFeedRation } from './helper';

const UpdateFeedRation = ({ params: { id }, router }) => {
  const [{ data: ration, isLoading }] = useFetchById(getFeedRation, id, {
    onError: () => router.push(feedRationsPath),
  });

  const onSubmit = (data) => {
    return updateFeedRation(id, serializeFeedRation(data))
      .then(() => {
        showToastrMessage('component.toastr.feedRation.updated');
        router.push(feedRationsPath);
      })
      .catch((errors) => handleFormErrors(errors, medicationErrorKeys));
  };

  return (
    <section className="small-12 column">
      <Panel>
        <Panel.Heading title={<FormattedMessage id="container.admin.feedRations.editRation" />}>
          {ration && <StatusBadge status={ration.active ? 'active' : 'disabled'} />}
        </Panel.Heading>
        <Panel.Body noPadding>
          <div className="row">
            <section className="small-12 medium-10 large-8 column">
              <Preloader isActive={isLoading} />
              <FormErrorsBox formName={feedRationFormName} excludedFields={rawMedicationErrorKeys} />
              {ration && (
                <FeedRationForm edit onSubmit={onSubmit} initialValues={feedRationToFormValues(ration)} />
              )}
            </section>
          </div>
        </Panel.Body>
      </Panel>
    </section>
  );
};

UpdateFeedRation.propTypes = {
  params: T.shape({ id: T.string.isRequired }).isRequired,
  router: T.object.isRequired,
};

export default UpdateFeedRation;
